'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _ajv = require('ajv');

var _ajv2 = _interopRequireDefault(_ajv);

var _TranscriptSegment = require('./TranscriptSegment');

var _TranscriptSegment2 = _interopRequireDefault(_TranscriptSegment);

var _TranscriptWord = require('./TranscriptWord');

var _TranscriptWord2 = _interopRequireDefault(_TranscriptWord);

var _Speaker = require('./Speaker');

var _Speaker2 = _interopRequireDefault(_Speaker);

var _KaldiAdapter = require('./adapters/KaldiAdapter');

var _KaldiAdapter2 = _interopRequireDefault(_KaldiAdapter);

var _MediaTaggerAdapter = require('./adapters/MediaTaggerAdapter');

var _MediaTaggerAdapter2 = _interopRequireDefault(_MediaTaggerAdapter);

var _OctoAdapter = require('./adapters/OctoAdapter');

var _OctoAdapter2 = _interopRequireDefault(_OctoAdapter);

var _GentleAdapter = require('./adapters/GentleAdapter');

var _GentleAdapter2 = _interopRequireDefault(_GentleAdapter);

var _schema = require('../schema.json');

var _schema2 = _interopRequireDefault(_schema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TranscriptRecord = new _immutable2.default.Record({
  speakers: new _immutable2.default.List(),
  segments: new _immutable2.default.List()
});

var Transcript = function (_TranscriptRecord) {
  _inherits(Transcript, _TranscriptRecord);

  function Transcript() {
    _classCallCheck(this, Transcript);

    return _possibleConstructorReturn(this, (Transcript.__proto__ || Object.getPrototypeOf(Transcript)).apply(this, arguments));
  }

  _createClass(Transcript, [{
    key: 'slice',
    value: function slice() {
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var end = arguments[1];

      var segments = this.segments.filter(function (segment) {
        return segment.getEnd() > start && (segment.getStart() < end || !end);
      }).map(function (segment) {
        return new _TranscriptSegment2.default({
          speaker: segment.speaker,
          words: segment.words.filter(function (word) {
            return word.end > start && (word.start < end || !end);
          }).map(function (word) {
            return new _TranscriptWord2.default({
              start: word.start - start >= 0 ? word.start - start : 0,
              end: word.end - start,
              id: word.id,
              text: word.text
            });
          })
        });
      });

      return new Transcript({ speakers: this.speakers, segments: segments });
    }
  }, {
    key: 'toJson',
    value: function toJson() {
      return {
        speakers: this.speakers.toArray().map(function (speaker) {
          return {
            name: speaker.name
          };
        }),
        segments: this.segments.toArray().map(function (segment) {
          return {
            words: segment.words.toArray().map(function (word) {
              return {
                text: word.text,
                start: word.start,
                end: word.end
              };
            }),
            speaker: segment.speaker
          };
        })
      };
    }
  }], [{
    key: 'fromJson',
    value: function fromJson(json) {
      this.validateJson(json);

      var speakers = new _immutable2.default.List(json.speakers.map(function (speaker) {
        return new _Speaker2.default(speaker);
      }));

      var segments = new _immutable2.default.List(json.segments.map(function (_ref) {
        var speaker = _ref.speaker,
            words = _ref.words;
        return new _TranscriptSegment2.default({
          speaker: speaker,
          words: new _immutable2.default.List(words.map(function (_ref2) {
            var start = _ref2.start,
                end = _ref2.end,
                text = _ref2.text,
                guid = _ref2.guid;
            return new _TranscriptWord2.default({
              start: start,
              end: end,
              text: text,
              id: guid
            });
          }))
        });
      }));

      return new Transcript({
        speakers: speakers,
        segments: segments
      });
    }
  }, {
    key: 'fromMediaTagger',
    value: function fromMediaTagger(json) {
      return _MediaTaggerAdapter2.default.parse(json);
    }
  }, {
    key: 'fromKaldi',
    value: function fromKaldi(transcriptJson, segmentsJson) {
      return _KaldiAdapter2.default.parse(transcriptJson, segmentsJson);
    }
  }, {
    key: 'fromOcto',
    value: function fromOcto(json) {
      return _OctoAdapter2.default.parse(json);
    }
  }, {
    key: 'fromGentle',
    value: function fromGentle(json) {
      return _GentleAdapter2.default.parse(json);
    }
  }, {
    key: 'validateJson',
    value: function validateJson(json) {
      var ajv = new _ajv2.default();
      var valid = ajv.validate(_schema2.default, json);
      if (!valid) {
        throw new Error('invalid transcript JSON:\n' + JSON.stringify(ajv.errors, null, 2));
      }
      return true;
    }
  }]);

  return Transcript;
}(TranscriptRecord);

exports.default = Transcript;